(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventPlaceDialogController', EventPlaceDialogController);

    EventPlaceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EventPlace'];

    function EventPlaceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, EventPlace) {
        var vm = this;
        vm.eventPlace = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:eventPlaceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.eventPlace.id !== null) {
                EventPlace.update(vm.eventPlace, onSaveSuccess, onSaveError);
            } else {
                EventPlace.save(vm.eventPlace, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
